export default class Calculated {
    key = (() => { throw new Error("CalculatedInputType.Key is expected to be overriden"); });
    getValue = () => { // (inputUser, calculatedInput)
        throw new Error("CalculatedInputType.getValue is expected to be overriden");
    };
}